import { render, staticRenderFns } from "./colorpicker.vue?vue&type=template&id=260a6030&"
import script from "./colorpicker.vue?vue&type=script&lang=js&"
export * from "./colorpicker.vue?vue&type=script&lang=js&"
import style0 from "./colorpicker.vue?vue&type=style&index=0&id=260a6030&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260a6030')) {
      api.createRecord('260a6030', component.options)
    } else {
      api.reload('260a6030', component.options)
    }
    module.hot.accept("./colorpicker.vue?vue&type=template&id=260a6030&", function () {
      api.rerender('260a6030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/colorpicker.vue"
export default component.exports